import { createSlice } from "@reduxjs/toolkit";

export const reqtCategoryListSlice = createSlice({
  name: "reqtCategoryListSlice",
  initialState: {
    reqtCategoryList: [],
  },
  reducers: {
    setReqtCategoryList: (currentSlice, action) => {
      currentSlice.reqtCategoryList = action.payload;
    },
  },
});

export const { setReqtCategoryList } = reqtCategoryListSlice.actions;
export const reqtCategoryListReducer = reqtCategoryListSlice.reducer;
